
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/severalbrands/key-considerations",
      function () {
        return require("private-next-pages/severalbrands/key-considerations.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/severalbrands/key-considerations"])
      });
    }
  